import { cn } from "@lattice-php/ui/lib/utils";
import type { ColumnCellComponent } from "@lattice-php/table/registry";
import { PreviewableImage } from "@lattice-php/ui/primitives/image-preview";

export const ImageCell: ColumnCellComponent<"column.image"> = ({ column, props, value }) => {
  const url = typeof value === "string" ? value : "";

  if (url === "") {
    return null;
  }

  const size = props.size ?? 32;

  return (
    <PreviewableImage
      alt={column.props.label ?? ""}
      className={cn("object-cover", props.circular ? "rounded-full" : "rounded-lt-sm")}
      height={size}
      previewable={props.previewable}
      src={url}
      testId={`preview-${column.key}`}
      width={size}
    />
  );
};
